<template>
  <div class="main-container">
    <el-card class="filter-container" shadow="never">
      <div>
        <i class="el-icon-search"></i>
        <span>筛选搜索</span>
        <el-button
          style="float: right"
          @click="handleAddCleaning"
          type="primary"
          size="small">
          添加清洁计划
        </el-button>
      </div>
      <div class="form-container">
        <el-form :inline="true" :model="searchForm" size="small" label-width="120px">
          <el-form-item :label="$t('roomcleaning.room')">
            <el-select v-model="searchForm.roomId" :placeholder="$t('roomcleaning.selectRoom')" clearable filterable>
              <el-option
                v-for="item in roomOptions"
                :key="item.id"
                :label="item.roomName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('roomcleaning.cleaningType')">
            <el-select v-model="searchForm.cleaningType" :placeholder="$t('roomcleaning.selectCleaningType')" clearable>
              <el-option :label="$t('roomcleaning.routineCleaning')" value="常规清洁"></el-option>
              <el-option :label="$t('roomcleaning.deepCleaning')" value="深度清洁"></el-option>
              <el-option :label="$t('roomcleaning.equipmentMaintenance')" value="设备维护"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('common.status')">
            <el-select v-model="searchForm.status" :placeholder="$t('common.selectStatus')" clearable>
              <el-option :label="$t('roomcleaning.pending')" value="待处理"></el-option>
              <el-option :label="$t('roomcleaning.inProgress')" value="进行中"></el-option>
              <el-option :label="$t('roomcleaning.completed')" value="已完成"></el-option>
              <el-option :label="$t('roomcleaning.cancelled')" value="已取消"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('roomcleaning.dateRange')">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              :range-separator="$t('roomcleaning.dateRangeSeparator')"
              :start-placeholder="$t('roomcleaning.startDate')"
              :end-placeholder="$t('roomcleaning.endDate')"
              value-format="yyyy-MM-dd"
              @change="handleDateRangeChange">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">{{ $t('common.search') }}</el-button>
            <el-button @click="resetSearch">{{ $t('common.reset') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    
    <el-card class="table-container">
      <div class="calendar-switch">
        <el-switch
          v-model="showCalendarView"
          active-text="日历视图"
          inactive-text="列表视图"
          @change="handleViewChange">
        </el-switch>
      </div>
      
      <!-- 列表视图 -->
      <div v-show="!showCalendarView">
        <el-table
          v-loading="listLoading"
          :data="cleaningList"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column prop="id" :label="$t('table.id')" width="80" align="center"></el-table-column>
          <el-table-column prop="roomName" :label="$t('roomcleaning.roomName')" align="center"></el-table-column>
          <el-table-column prop="cleaningType" :label="$t('roomcleaning.cleaningType')" align="center"></el-table-column>
          <el-table-column prop="cleaningDate" :label="$t('roomcleaning.cleaningDate')" align="center"></el-table-column>
          <el-table-column prop="startTime" :label="$t('roomcleaning.startTime')" align="center"></el-table-column>
          <el-table-column prop="endTime" :label="$t('roomcleaning.endTime')" align="center"></el-table-column>
          <el-table-column prop="cleanerName" :label="$t('roomcleaning.cleaner')" align="center"></el-table-column>
          <el-table-column prop="status" :label="$t('common.status')" align="center">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)">{{ getStatusText(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="remark" :label="$t('roomcleaning.remark')" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('table.actions')" width="300" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleInfoCleaning(scope.row)">{{ $t('table.view') }}</el-button>
              <el-button type="text" size="small" @click="handleEditCleaning(scope.row)" v-if="scope.row.status === '待处理'">{{ $t('table.edit') }}</el-button>
              <el-button type="text" size="small" @click="handleAssignCleaner(scope.row)" v-if="scope.row.status === '待处理'">{{ $t('roomcleaning.assignCleaner') }}</el-button>
              <el-button 
                type="text" 
                size="small" 
                @click="handleUpdateStatus(scope.row, '进行中')" 
                v-if="scope.row.status === '待处理' && scope.row.cleanerName">{{ $t('roomcleaning.startCleaning') }}</el-button>
              <el-button 
                type="text" 
                size="small" 
                @click="handleUpdateStatus(scope.row, '已完成')" 
                v-if="scope.row.status === '进行中'">{{ $t('roomcleaning.completeCleaning') }}</el-button>
              <el-button 
                type="text" 
                size="small" 
                style="color: #F56C6C" 
                @click="handleUpdateStatus(scope.row, '已取消')" 
                v-if="scope.row.status === '待处理' || scope.row.status === '进行中'">{{ $t('common.cancel') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      
      <!-- 日历视图 -->
      <div v-show="showCalendarView" class="calendar-view">
        <el-calendar v-model="calendarDate">
          <template slot="dateCell" slot-scope="{date, data}">
            <div class="calendar-day">
              <div class="calendar-day-number">{{ data.day.split('-').slice(2).join('') }}</div>
              <div class="calendar-events">
                <div 
                  v-for="(event, index) in getCalendarEvents(date)" 
                  :key="index"
                  :class="['calendar-event', 'event-' + getStatusClass(event.status)]"
                  @click="handleInfoCleaning(event)">
                  {{ event.roomName }} {{ event.cleaningType }}
                </div>
              </div>
            </div>
          </template>
        </el-calendar>
      </div>
    </el-card>
    
    <!-- 指派人员对话框 -->
    <el-dialog title="指派清洁人员" :visible.sync="assignDialogVisible" width="30%">
      <el-form :model="assignForm" label-width="120px">
        <el-form-item label="房间">
          <span>{{ assignForm.roomName }}</span>
        </el-form-item>
        <el-form-item label="清洁类型">
          <span>{{ assignForm.cleaningType }}</span>
        </el-form-item>
        <el-form-item label="清洁日期时间">
          <span>{{ assignForm.cleaningDate }} {{ assignForm.startTime }}-{{ assignForm.endTime }}</span>
        </el-form-item>
        <el-form-item label="清洁人员" prop="cleanerName">
          <el-select v-model="assignForm.cleanerName" placeholder="请选择清洁人员" filterable>
            <el-option
              v-for="item in cleanerOptions"
              :key="item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input 
            type="textarea" 
            v-model="assignForm.remark" 
            placeholder="请输入备注信息"
            :rows="3"
            maxlength="200"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="assignDialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitAssignForm">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
    
    <!-- 添加清洁计划对话框 -->
    <el-dialog :title="isEdit ? '编辑清洁计划' : '新增清洁计划'" :visible.sync="addEditDialogVisible" width="40%">
      <el-form :model="cleaningForm" :rules="cleaningRules" ref="cleaningForm" label-width="120px">
        <el-form-item label="房间" prop="roomId">
          <el-select v-model="cleaningForm.roomId" placeholder="请选择房间" filterable>
            <el-option
              v-for="item in roomOptions"
              :key="item.id"
              :label="item.roomName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="清洁类型" prop="cleaningType">
          <el-select v-model="cleaningForm.cleaningType" placeholder="请选择清洁类型">
            <el-option label="常规清洁" value="常规清洁"></el-option>
            <el-option label="深度清洁" value="深度清洁"></el-option>
            <el-option label="设备维护" value="设备维护"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计划类型" prop="planType">
          <el-radio-group v-model="cleaningForm.planType">
            <el-radio label="recurring">{{ $t('roomcleaning.recurringPlan') }}</el-radio>
            <el-radio label="specific">{{ $t('roomcleaning.specificDatePlan') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="cleaningForm.planType === 'recurring'">
          <el-form-item label="重复周期" prop="dayOfWeek">
            <el-select v-model="cleaningForm.dayOfWeek" placeholder="请选择重复周期">
              <el-option label="周一" value="1"></el-option>
              <el-option label="周二" value="2"></el-option>
              <el-option label="周三" value="3"></el-option>
              <el-option label="周四" value="4"></el-option>
              <el-option label="周五" value="5"></el-option>
              <el-option label="周六" value="6"></el-option>
              <el-option label="周日" value="0"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="清洁日期" prop="specificDate">
            <el-date-picker
              v-model="cleaningForm.specificDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </template>
        <el-form-item label="开始时间" prop="startTime">
          <el-time-picker
            v-model="cleaningForm.startTime"
            format="HH:mm"
            value-format="HH:mm"
            placeholder="选择时间">
          </el-time-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-time-picker
            v-model="cleaningForm.endTime"
            format="HH:mm"
            value-format="HH:mm"
            placeholder="选择时间">
          </el-time-picker>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input 
            type="textarea" 
            v-model="cleaningForm.remark" 
            placeholder="请输入备注信息"
            :rows="3"
            maxlength="200"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addEditDialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitCleaningForm">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { formatDate } from '@/utils/date'

export default {
  filters: {
    formatDate(time, format) {
      if (time) {
        return formatDate(new Date(time), format)
      }
      return ''
    }
  },
  data() {
    return {
      searchForm: {
        roomId: '',
        cleaningType: '',
        status: '',
        startDate: '',
        endDate: ''
      },
      dateRange: [],
      cleaningList: [],
      listLoading: false,
      multipleSelection: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      roomOptions: [],
      cleanerOptions: [
        { name: '张清洁' },
        { name: '李维护' },
        { name: '王保洁' },
        { name: '赵阿姨' },
        { name: '钱师傅' }
      ],
      showCalendarView: false,
      calendarDate: new Date(),
      calendarEvents: [],
      assignDialogVisible: false,
      assignForm: {
        id: null,
        roomName: '',
        cleaningType: '',
        cleaningDate: '',
        startTime: '',
        endTime: '',
        cleanerName: '',
        remark: ''
      },
      addEditDialogVisible: false,
      isEdit: false,
      cleaningForm: {
        id: null,
        roomId: '',
        cleaningType: '常规清洁',
        planType: 'specific',
        dayOfWeek: '1',
        specificDate: '',
        startTime: '',
        endTime: '',
        remark: ''
      },
      cleaningRules: {
        roomId: [
          { required: true, message: '请选择房间', trigger: 'change' }
        ],
        cleaningType: [
          { required: true, message: '请选择清洁类型', trigger: 'change' }
        ],
        dayOfWeek: [
          { required: true, message: '请选择重复周期', trigger: 'change' }
        ],
        specificDate: [
          { required: true, message: '请选择清洁日期', trigger: 'change' }
        ],
        startTime: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.getRoomOptions()
    this.getCleaningList()
  },
  methods: {
    getRoomOptions() {
      this.$http({
        url: '/room/list',
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.roomOptions = data.list || []
        }
      })
    },
    getCleaningList() {
      this.listLoading = true
      this.$http({
        url: '/roomcleaning/page',
        method: 'get',
        params: {
          page: this.currentPage,
          limit: this.pageSize,
          roomId: this.searchForm.roomId,
          cleaningType: this.searchForm.cleaningType,
          status: this.searchForm.status,
          startDate: this.searchForm.startDate,
          endDate: this.searchForm.endDate
        }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.cleaningList = data.page.list
          this.total = data.page.totalCount
          this.calendarEvents = [...this.cleaningList]
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    getStatusType(status) {
      if (status === '已完成') return 'success'
      if (status === '进行中') return 'primary'
      if (status === '待处理') return 'warning'
      if (status === '已取消') return 'info'
      return 'info'
    },
    getStatusText(status) {
      if (status === '已完成') return this.$t('roomcleaning.completed')
      if (status === '进行中') return this.$t('roomcleaning.inProgress')
      if (status === '待处理') return this.$t('roomcleaning.pending')
      if (status === '已取消') return this.$t('roomcleaning.cancelled')
      return status
    },
    getStatusClass(status) {
      if (status === '已完成') return 'success'
      if (status === '进行中') return 'primary'
      if (status === '待处理') return 'warning'
      if (status === '已取消') return 'cancel'
      return 'default'
    },
    getCalendarEvents(date) {
      const dateStr = formatDate(date, 'yyyy-MM-dd')
      return this.calendarEvents.filter(event => {
        return formatDate(new Date(event.cleaningDate), 'yyyy-MM-dd') === dateStr
      })
    },
    handleViewChange(val) {
      if (val) {
        // 切换到日历视图，加载当月数据
        const firstDay = new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth(), 1)
        const lastDay = new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth() + 1, 0)
        
        this.searchForm.startDate = formatDate(firstDay, 'yyyy-MM-dd')
        this.searchForm.endDate = formatDate(lastDay, 'yyyy-MM-dd')
        this.getCleaningList()
      }
    },
    handleDateRangeChange(val) {
      if (val) {
        this.searchForm.startDate = val[0]
        this.searchForm.endDate = val[1]
      } else {
        this.searchForm.startDate = ''
        this.searchForm.endDate = ''
      }
    },
    handleSearch() {
      this.currentPage = 1
      this.getCleaningList()
    },
    resetSearch() {
      this.searchForm = {
        roomId: '',
        cleaningType: '',
        status: '',
        startDate: '',
        endDate: ''
      }
      this.dateRange = []
      this.handleSearch()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getCleaningList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getCleaningList()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleInfoCleaning(row) {
      this.$http({
        url: `/roomcleaning/info/${row.id}`,
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0) {
          const cleaningData = data.roomCleaning
          
          this.$alert(`
            <div class="cleaning-info">
              <p><b>房间：</b>${cleaningData.roomName}</p>
              <p><b>清洁类型：</b>${cleaningData.cleaningType}</p>
              <p><b>清洁日期：</b>${formatDate(new Date(cleaningData.cleaningDate), 'yyyy-MM-dd')}</p>
              <p><b>时间段：</b>${cleaningData.startTime} - ${cleaningData.endTime}</p>
              <p><b>状态：</b>${cleaningData.status}</p>
              <p><b>清洁人员：</b>${cleaningData.cleanerName || '未指派'}</p>
              <p><b>备注：</b>${cleaningData.remark || '无'}</p>
            </div>
          `, this.$t('roomcleaning.cleaningPlanDetail'), {
            dangerouslyUseHTMLString: true,
            confirmButtonText: this.$t('common.close')
          })
        }
      })
    },
    handleAddCleaning() {
      this.isEdit = false
      this.cleaningForm = {
        id: null,
        roomId: '',
        cleaningType: '常规清洁',
        planType: 'specific',
        dayOfWeek: '1',
        specificDate: formatDate(new Date(), 'yyyy-MM-dd'),
        startTime: '08:00',
        endTime: '10:00',
        remark: ''
      }
      this.addEditDialogVisible = true
    },
    handleEditCleaning(row) {
      this.isEdit = true
      this.$http({
        url: `/roomcleaning/info/${row.id}`,
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0) {
          const cleaningData = data.roomCleaning
          
          // 判断是周期性还是指定日期
          const planType = cleaningData.dayOfWeek ? 'recurring' : 'specific'
          
          this.cleaningForm = {
            id: cleaningData.id,
            roomId: cleaningData.roomId,
            cleaningType: cleaningData.cleaningType,
            planType: planType,
            dayOfWeek: cleaningData.dayOfWeek || '1',
            specificDate: formatDate(new Date(cleaningData.cleaningDate), 'yyyy-MM-dd'),
            startTime: cleaningData.startTime,
            endTime: cleaningData.endTime,
            remark: cleaningData.remark || ''
          }
          
          this.addEditDialogVisible = true
        }
      })
    },
    submitCleaningForm() {
      this.$refs.cleaningForm.validate((valid) => {
        if (valid) {
          // 验证时间是否合理
          if (this.cleaningForm.startTime >= this.cleaningForm.endTime) {
            this.$message.error(this.$t('roomcleaning.endTimeMustBeAfterStartTime'))
            return
          }
          
          let url = '/roomcleaning/save'
          let method = 'post'
          
          const requestData = {
            id: this.cleaningForm.id,
            roomId: this.cleaningForm.roomId,
            cleaningType: this.cleaningForm.cleaningType,
            remark: this.cleaningForm.remark
          }
          
          if (this.cleaningForm.planType === 'recurring') {
            url = '/roomcleaning/recurring'
            requestData.dayOfWeek = this.cleaningForm.dayOfWeek
          } else {
            url = '/roomcleaning/specific'
            requestData.specificDate = this.cleaningForm.specificDate
          }
          
          requestData.startTime = this.cleaningForm.startTime
          requestData.endTime = this.cleaningForm.endTime
          
          this.$http({
            url: url,
            method: method,
            data: requestData
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: this.isEdit ? this.$t('common.updateSuccess') : this.$t('common.addSuccess'),
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.addEditDialogVisible = false
                  this.getCleaningList()
                }
              })
            } else {
              this.$message.error(data.msg || this.$t('common.operationFailed'))
            }
          })
        }
      })
    },
    handleAssignCleaner(row) {
      this.assignForm = {
        id: row.id,
        roomName: row.roomName,
        cleaningType: row.cleaningType,
        cleaningDate: formatDate(new Date(row.cleaningDate), 'yyyy-MM-dd'),
        startTime: row.startTime,
        endTime: row.endTime,
        cleanerName: row.cleanerName || '',
        remark: row.remark || ''
      }
      this.assignDialogVisible = true
    },
    submitAssignForm() {
      if (!this.assignForm.cleanerName) {
        this.$message.error(this.$t('roomcleaning.pleaseSelectCleaner'))
        return
      }
      
      this.$http({
        url: '/roomcleaning/assign',
        method: 'post',
        data: {
          id: this.assignForm.id,
          cleanerName: this.assignForm.cleanerName,
          remark: this.assignForm.remark
        }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$message({
            message: this.$t('roomcleaning.assignSuccess'),
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.assignDialogVisible = false
              this.getCleaningList()
            }
          })
        } else {
          this.$message.error(data.msg || this.$t('common.operationFailed'))
        }
      })
    },
    handleUpdateStatus(row, status) {
      let confirmMessage = this.$t('roomcleaning.confirmStatusChangeTo') + `"${status}"` + '?'
      
      if (status === '进行中' && !row.cleanerName) {
        this.$message.warning(this.$t('roomcleaning.pleaseAssignCleanerFirst'))
        return
      }
      
      this.$confirm(confirmMessage, this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/roomcleaning/status',
          method: 'post',
          params: {
            id: row.id,
            status: status
          }
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: this.$t('common.statusUpdateSuccess'),
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getCleaningList()
              }
            })
          } else {
            this.$message.error(data.msg || this.$t('common.operationFailed'))
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.main-container {
  padding: 20px;
}
.filter-container {
  margin-bottom: 20px;
}
.form-container {
  margin-top: 20px;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
.calendar-switch {
  margin-bottom: 20px;
  text-align: right;
}
.calendar-day {
  height: 100%;
  position: relative;
}
.calendar-day-number {
  position: absolute;
  top: 5px;
  right: 5px;
}
.calendar-events {
  margin-top: 25px;
  overflow: auto;
  max-height: 90px;
}
.calendar-event {
  padding: 2px 4px;
  margin-bottom: 2px;
  border-radius: 2px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.event-success {
  background-color: rgba(103, 194, 58, 0.2);
  color: #67C23A;
}
.event-primary {
  background-color: rgba(64, 158, 255, 0.2);
  color: #409EFF;
}
.event-warning {
  background-color: rgba(230, 162, 60, 0.2);
  color: #E6A23C;
}
.event-cancel {
  background-color: rgba(144, 147, 153, 0.2);
  color: #909399;
}
.event-default {
  background-color: rgba(144, 147, 153, 0.2);
  color: #909399;
}
</style> 